import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { useAirModal } from '@air/provider-modal';
import { useShortIdContext } from '@air/provider-short-id';

import { SharePublicClipModal } from '~/components/Modals/SharePublicClipModal';
import { useURLBoardIdSelector } from '~/hooks/useURLBoardIdSelector';
import { centralizedClipSelector } from '~/store/centralizedClip/selectors';
import { getPublicClipInABoardShareUrl } from '~/swr-hooks/shortUrl/utils';

export const usePublicBoardAssetShare = () => {
  const [sharePublicClip] = useAirModal(SharePublicClipModal);
  const { shortId } = useShortIdContext();
  const boardId = useURLBoardIdSelector();
  const clip = useSelector(centralizedClipSelector);

  const sharePublicBoardAsset = useCallback(() => {
    if (!boardId) {
      return;
    }

    sharePublicClip({
      id: clip.id,
      url: getPublicClipInABoardShareUrl(shortId, clip.id, boardId),
      trackLocation: 'public-asset-page',
    });
  }, [boardId, clip.id, sharePublicClip, shortId]);

  return { sharePublicBoardAsset };
};
